import AppTheme from "../../../frontend/shared-theme/AppTheme";
import type { } from '@mui/x-date-pickers/themeAugmentation';
import type { } from '@mui/x-charts/themeAugmentation';
import type { } from '@mui/x-data-grid-pro/themeAugmentation';
import type { } from '@mui/x-tree-view/themeAugmentation';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { Container, Divider, Typography } from "@mui/material";
import { useColorScheme } from '@mui/material/styles';
import Footer from "../../../frontend/components/Footer";
import AppAppBar from "../../../frontend/components/AppAppBar";
import WifiOffIcon from '@mui/icons-material/WifiOff';

export default function NotFound(props: { disableCustomTheme?: boolean }) {
  return (
    <AppTheme {...props}>
      <NotFoundContent />
    </AppTheme>
  )
}

function NotFoundContent() {
  const { mode, systemMode } = useColorScheme();

  return (
    <>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: 'flex' }}>
        <AppAppBar />
        <Box
          id="hero"
          sx={(theme) => ({
            width: '100%',
            backgroundRepeat: 'no-repeat',
            backgroundImage:
              'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 90%), transparent)',
            ...theme.applyStyles('dark', {
              backgroundImage:
                'radial-gradient(ellipse 80% 50% at 50% -20%, hsl(210, 100%, 16%), transparent)',
            }),
          })}
        >
          <Box>
            <Stack
              spacing={2}
              sx={{
                alignItems: 'center',
                mx: 3,
                pb: 5,
                mt: { xs: 8, md: 0 },
              }}
            >
            </Stack>
            <Container
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 4,
                alignItems: 'center',
                pt: 15,
                pb: { xs: 8, sm: 12 },
              }}
            >
              <Stack
                spacing={2}
                useFlexGap
                sx={{ alignItems: 'center', width: { xs: '100%', sm: '70%' } }}
              >
                <Typography
                  variant="h1"
                  sx={{
                    textAlign: 'center',
                    fontSize: '3rem',
                  }}
                >
                  Página&nbsp;
                  <Typography
                    component="span"
                    variant="h1"
                    sx={(theme) => ({
                      fontSize: 'inherit',
                      color: 'primary.main',
                      ...theme.applyStyles('dark', {
                        color: 'primary.light',
                      }),
                    })}
                  >
                    não encontrada
                  </Typography>
                </Typography>
              </Stack>
              <WifiOffIcon fontSize="large" sx={{ color: "error" }} />
              <Typography color="text.secondary" textAlign={"center"}>
                A p&aacute;gina que voc&ecirc; est&aacute; procurando n&atilde;o existe.
              </Typography>
            </Container>
          </Box>
          <Divider sx={{ mt: 5 }} />
          <Footer />
        </Box>
      </Box>
    </>
  );
}
